/**
 *
 * CustomizedCalendar
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterLuxon } from '@mui/x-date-pickers-pro/AdapterLuxon';

import { ArrowLeftIcon, ArrowRightIcon } from '../../../../../assets/v2/icons';
import { popperStyles } from '../../Calendar.styles';
import { zoneIgnoredDate } from '../../../../../utils/helpers';
import { ActionBar, SwitchViewButton } from './components';

// Because of implementation of v5 dayOfWeekFormatter that is impossible to achieve the UX goal without workaround
// That approach is faster than override Luxon class
// That workaround will work only if Mon is a first week day
const weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
let weekdayI = 0;
const getWeekday = () => {
  const weekday = weekdays[weekdayI];
  // eslint-disable-next-line no-unused-expressions
  weekdayI < 6 ? (weekdayI += 1) : (weekdayI = 0);
  return weekday;
};

function CustomizedCalendar({ value, onSave, onChange, ...props }) {
  const ActionBarComponent = (actionBarProps) => (
    <ActionBar
      customAccept={onSave}
      customClear={() => onChange(null)}
      {...actionBarProps}
    />
  );

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <DatePicker
        components={{
          LeftArrowIcon: ArrowLeftIcon,
          RightArrowIcon: ArrowRightIcon,
          ActionBar: ActionBarComponent,
          SwitchViewButton,
        }}
        componentsProps={{
          actionBar: {
            actions: ['clear', 'accept'],
          },
        }}
        PopperProps={{ sx: popperStyles }}
        closeOnSelect={false}
        showDaysOutsideCurrentMonth
        dayOfWeekFormatter={getWeekday}
        {...props}
        value={value ? zoneIgnoredDate(value) : null}
        onChange={(date) => {
          onChange(zoneIgnoredDate(date));
        }}
      />
    </LocalizationProvider>
  );
}

CustomizedCalendar.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func,
};

export default memo(CustomizedCalendar);
